import React from 'react'
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormInput from '../../../../library/form/components/FormInput';
import FormSlider from '../../../../library/form/components/FormSlider'
import coreSetting from '../../../../helper/coreSetting';
import FormLabel from '../../../../library/form/components/FormLabel'
import FormRichText from '../../../../library/form/components/FormRichText'
import FormWrapper from '../../../../library/form/components/FormWrapper'
import FormSH from '../../../../library/form/components/FormSH';
import { UiRow, UiCol } from "../../../../library/layout/Index";
import FormAMCStatus from '../../../../library/form/components/FormAMCStatus';
import SarasTrans from '../../../../library/notifications/SarasTrans';

const TaskCMNHeaderEditor = (props) => {
    const { formObject } = props;

    return (
        <div>
            <UiCol>
                <ul>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "taskId" }} value="ID" />
                        </span>
                        <FormROValue className="uiVal" formObject={formObject} rowKey="" action={{ paramName: "taskId" }} />
                    </li>
                    <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "profile" }} >
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "profile" }} value="" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" autofocus
                            action={{
                                InputType: "ac", actionId:"refresh", paramName: "profile", acMethod: "ProfileName", actionParam:{ updateProfile: "1" },
                                acDepCtrl: { dparam: "%dataList.valLDT", reqPerm: 1 }
                            }}
                        />
                        <FormSH formObject={formObject} rowKey=""
                            action={{ actionId: "new", paramName: "profile",  actionName: "proComp", actionParam: {}, containerKey: "popup" }}
                        ></FormSH>
                    </FormWrapper>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "taskDate" }} value="Task Date" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className=""
                            action={{ InputType: "dp", actionId:"refresh", paramName: "taskDate", actionParam:{ updateAMC: "1" } }} />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "startDate" }} value="Start Date" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className=""
                            action={{ InputType: "dp", paramName: "startDate" }} />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "visitDate" }} value="Visit Scheduled On" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className=""
                            action={{ InputType: "dp", paramName: "visitDate" }} />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "status" }} value="Status" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" id="acCompanyTxt" className=""
                            action={{ InputType: "ac", paramName: "status", acMethod: "CategoryDetail", acDepCtrl: { dparam: "%dataList.valLCat", excludeGroupCode: "%dataList.excludeGroupCode" } }}
                        />
                        {/* <FormSH formObject={formObject} rowKey=""
                            action={{ actionId: "new", paramName: "status",  actionName: "catDetail", actionParam: {}, containerKey: "popup" }}
                            >
                        </FormSH> */}
                    </li>
                    <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "area" }} >
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "area" }} value="Task Area" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" id="acCompanyTxt" className="uiInput"
                            action={{ InputType: "ac", paramName: "area", acMethod: "CategoryDetail", acDepCtrl: { dparam: "%dataList.valLCat" } }}
                        />
                        <FormSH formObject={formObject} rowKey=""
                            action={{ actionId: "new", paramName: "area",  actionName: "catDetail", actionParam: {}, containerKey: "popup" }}
                            >
                        </FormSH>
                    </FormWrapper>

                </ul>
            </UiCol>
            <UiCol>
                <ul>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "requestedBy" }} value="Requested By" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className=""
                            action={{ InputType: "input", paramName: "requestedBy" }}
                        />
                    </li>
                    <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "profile2" }} >
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "profile2" }} value="" />
                        </span>
                        <FormInput formObject={formObject} rowKey=""
                            action={{
                                InputType: "ac", actionId:"refresh", paramName: "profile2", acMethod: "ProfileName", actionParam:{ updateProfile: "1" },
                                acDepCtrl: { dparam: "%dataList.valLDT", reqPerm: 1 }
                            }}
                        />
                        <FormSH formObject={formObject} rowKey=""
                            action={{ actionId: "new", paramName: "profile2",  actionName: "proComp", actionParam: {}, containerKey: "popup" }}
                        ></FormSH>
                    </FormWrapper>
                    <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "address" }} >
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "address" }} value="Visit Address" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" id="acCompanyTxt" className="" rows="3" cols="40" useValF="1"
                            action={{ 
                                InputType: "ac", paramName: "address", acMethod: "ProfileAddress", 
                                acDepCtrl: { dptid: "%dataList.valLDT", dpid:"#profile" }, acValidate:"0" }}
                        />
                    </FormWrapper>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "priority" }} value="Priority" />
                        </span>
                        <div className="uiInline">
                            <FormSlider formObject={formObject} rowKey="" action={{ paramName: "priority", datalist: coreSetting.priorityList.Priority }} />
                        </div>
                    </li>
                    <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "type1" }} >
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "type1" }} value="Task Type" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" id="acCompanyTxt" className="uiInput"
                            action={{ InputType: "ac", paramName: "type1", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }}
                        />

                        <FormSH formObject={formObject} rowKey="" 
                            action={{ actionId: "new", paramName: "type1",  actionName: "catDetail", actionParam: {}, containerKey: "popup" }}
                        >
                        </FormSH>
                    </FormWrapper>
                    <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "type2" }} >
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "type2" }} value="Call Type" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" id="acCompanyTxt" className="uiInput"
                            action={{ InputType: "ac", paramName: "type2", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }}
                        />

                        <FormSH formObject={formObject} rowKey="" 
                            action={{ actionId: "new", paramName: "type2",  actionName: "catDetail", actionParam: {}, containerKey: "popup" }}
                        >
                        </FormSH>
                    </FormWrapper>

                </ul>
            </UiCol>
            <UiRow>
                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiSpacer10" rowKey="" action={{ paramName: "amcStatusContainer" }} >
                    <div className='uiFlexBox'>
                        <span className="uiLbl">
                            <SarasTrans value="AMC Status" />
                        </span>
                        <FormAMCStatus formObject={formObject} rowKey="" action={{ paramName: "amcStatus" }}/>
                    </div>
                </FormWrapper>
                <div className="uiSpacer10">
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "taskDesc" }} value="Task Description" />
                    </span>
                    <FormRichText formObject={formObject} rowKey="" rows="4" cols="82" className=""
                        action={{ paramName: "taskDesc" }}
                    />
                </div>
                <div className="uiSpacer10">
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "preReq" }} value="Pre Requisite" />
                    </span>
                    <FormRichText formObject={formObject} rowKey="" rows="4" cols="82" className=""
                        action={{ paramName: "preReq" }}
                    />
                </div>
                <div className="uiSpacer10">
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "solution" }} value="Solution" />
                    </span>
                    <FormRichText formObject={formObject} rowKey="" rows="4" cols="82" className=""
                        action={{ paramName: "solution" }}
                    />
                </div>
            </UiRow>
        </div>
    )
}

export default TaskCMNHeaderEditor

